// src/components/AddFriendManager.jsx
import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../contexts/authContext';
import { API_URL } from '../lib/config';
import CommonButton from './CommonButton';
import './AddFriendManager.css';

const AddFriendManager = ({ partnerId, defaultNickname, onFriendAdded }) => {
    const { currentUser } = useAuth();
    const [showModal, setShowModal] = useState(false);
    const [friendNameInput, setFriendNameInput] = useState('');
    
    // 팝업 외부 클릭 시 닫기 위한 Ref
    const popupRef = useRef(null);

    const handleToggle = (e) => {
        e.stopPropagation();
        if (!showModal) {
            setFriendNameInput(defaultNickname || '');
            setShowModal(true);
        } else {
            setShowModal(false);
        }
    };

    // 팝업 바깥을 클릭하면 닫히는 로직
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setShowModal(false);
            }
        };

        if (showModal) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showModal]);

    const handleAddFriendSubmit = async (e) => {
        e.stopPropagation();
        if (!friendNameInput.trim()) return alert("이름을 입력해주세요.");
        
        try {
            const idToken = await currentUser.getIdToken();
            const response = await fetch(`${API_URL}/api/friends/add`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${idToken}` },
                body: JSON.stringify({ targetUserId: partnerId, customNickname: friendNameInput })
            });

            const data = await response.json();

            if (!response.ok) {
                // 백엔드에서 보낸 "이미 친구로 등록된 사용자입니다."가 data.message에 들어있습니다.
                throw new Error(data.message || '친구 추가 실패');
            }

            alert(`${friendNameInput}님을 친구로 추가했습니다!`);
            setShowModal(false);
            if (onFriendAdded) onFriendAdded(friendNameInput);
        } catch (error) {
            alert(`오류: ${error.message}`);
        }
    };

    return (
        // 1. 기준점: 버튼과 팝업을 감싸는 relative 컨테이너
        <div style={{ position: 'relative', display: 'inline-block' }} ref={popupRef}>
            
            {/* 2. 친구 추가 버튼 */}
            <button 
                className="add-friend-manager-btn" 
                onClick={handleToggle}
                title="친구 추가"
            >
                {showModal ? '×' : '+'} {/* 열리면 X, 닫히면 + */}
            </button>

            {/* 3. 팝업 창 (배경 없이 창만 뜸) */}
            {showModal && (
                <div className="afm-popover" onClick={(e) => e.stopPropagation()}>
                    <p className="afm-desc">저장할 이름을 입력하세요</p>

                    <input 
                        type="text" 
                        className="afm-input"
                        value={friendNameInput}
                        onChange={(e) => setFriendNameInput(e.target.value)}
                        autoFocus
                        placeholder={defaultNickname}
                        onKeyPress={(e) => e.key === 'Enter' && handleAddFriendSubmit(e)}
                    />

                    <div className="afm-buttons">
                        <CommonButton 
                            text="저장" 
                            variant="primary" 
                            onClick={handleAddFriendSubmit} 
                            style={{ flex: 1, padding: '8px', fontSize: '0.9rem' }} 
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddFriendManager;